module.exports = __webpack_public_path__ + "static/flying_sword-c2bda6069a099afa2a6e051da2f2f095.png";